import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-6 md:mb-8">
            <Icon name="Sparkles" size={18} color="var(--color-primary)" />
            <span className="text-xs md:text-sm font-medium font-cta text-primary">
              Premium SaaS Development Services
            </span>
          </div>
          
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-headline text-foreground mb-4 md:mb-6 leading-tight">
            Transform Your Vision Into
            <span className="block text-primary mt-2">Scalable SaaS Solutions</span>
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body mb-8 md:mb-10 max-w-3xl mx-auto leading-relaxed">
            From MVP development to enterprise-grade platforms, we architect digital transformation through strategic technical partnerships. Our comprehensive service portfolio combines deep technical expertise with business acumen to deliver measurable outcomes.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#services-overview"
              className="inline-flex items-center space-x-2 bg-primary text-primary-foreground px-6 md:px-8 py-3 md:py-4 rounded-md font-medium font-cta text-sm md:text-base hover:bg-primary/90 transition-all duration-200 shadow-lg hover:shadow-xl w-full sm:w-auto justify-center"
            >
              <span>Explore Services</span>
              <Icon name="ArrowRight" size={18} />
            </a>
            <a
              href="/contact"
              className="inline-flex items-center space-x-2 bg-card border-2 border-border text-foreground px-6 md:px-8 py-3 md:py-4 rounded-md font-medium font-cta text-sm md:text-base hover:bg-muted transition-all duration-200 w-full sm:w-auto justify-center"
            >
              <Icon name="Calendar" size={18} />
              <span>Schedule Consultation</span>
            </a>
          </div>
          
          <div className="mt-12 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {[
              { value: '50+', label: 'Projects Delivered' },
              { value: '98%', label: 'Client Satisfaction' },
              { value: '15+', label: 'Industries Served' },
              { value: '24/7', label: 'Support Available' }
            ]?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-primary mb-1 md:mb-2">
                  {stat?.value}
                </div>
                <div className="text-xs md:text-sm text-muted-foreground font-body">
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;